import styles from './Dashboard.module.css';

import { useState } from 'react';

import { MyInfo } from '../MyInfo/MyInfo';
import { NewPatroller } from '../NewPatroller/NewPatroller';
import { Patrollers } from '../Patrollers/Patrollers';

export const Dashboard = () => {
    const [ newPatroller, setNewPatroller ] = useState(null);

    return (
        <div className={ styles.dashboard }>
            <MyInfo />

            <NewPatroller onNewPatroller={ setNewPatroller } />

            <Patrollers newPatroller={ newPatroller } />
        </div>
    );
};